<template>
  <div class="section_container">
		<div id="random_option_content">
			<div id="random_option_box">
				<span class="question">PLEASE ENTER A QUESTION</span>
				<span class="question_mark">?</span>
				<input id="main_question"/>
				<div id="options">
					<input v-for="i in fields" :key="'field_'+i" :class="(i == option_index) ? 'chosen_option option' : 'option'"/>
					<span id="add_option" @click="fields++"><font-awesome-icon :icon="['fas', 'plus']" /></span>
				</div>
				<div id="timer_2">
					<img v-visible="reveal_timer >= 4" class="timer2_item" id="quarter2_4" style="width:77px;" src="../assets/images/timer_0_0.png"/>
					<img v-visible="reveal_timer >= 1" class="timer2_item" id="quarter2_1" src="../assets/images/timer_0_1.png"/>
					<img v-visible="reveal_timer >= 3" class="timer2_item" id="quarter2_3" style="width:77px;" src="../assets/images/timer_1_0.png"/>
					<img v-visible="reveal_timer >= 2" class="timer2_item" id="quarter2_2" src="../assets/images/timer_1_1.png"/>
				</div>
				<span class="submit_button" @click="pickOption">LET'S ROLL !</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data: function(){
			return {
				name: 'MultiChoiceVue',
				reveal_timer: 0,
				fields:2,
				option_index: null
			}
		},
		methods:{
			pickOption: function() {
				this.reveal_timer = 0;
				var i = setInterval(() => {
					if(++(this.reveal_timer) == 4){
						clearInterval(i);
						this.option_index = Math.floor(10*Math.random() % this.fields) + 1;
					}
				}, 500);
			}
		}
	}
</script>

<style scoped>
  .section_container{
    position: relative;
    width: 100%;
  }
</style>